import '../../scripts/common';

import '../../scripts/autosize';
import 'animate.css/animate.css';
import '../../scripts/animate';
import '../../scripts/picture';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Field from '../../components/base/Field';
import Socials from '../../components/simple/Socials';
import PageScrollBtn from '../../components/simple/PageScrollBtn';
import Popup from '../../components/base/Popup';
import './styles.css';

import '../../images/sprite/cross.svg';

import './getMail';

$(() => {
    Field.create();
    Header.create();
    Footer.create();
    Socials.create();
    PageScrollBtn.create();
    Popup.create();
});

$(document).on('submit', '.js-form-submit', e => {
    e.preventDefault();

    Popup.getInstance($('#popup-message')).open();
});
